export const JobStepNumber = {
  "Job Lead": 1,
  Contacted: 1,
  "Material and Trucking Details": 2,
  "Build Quote": 3,
  "Quote Shared": 3,
  "Customer Approval": 4,
  "Quote Approved": 4,
  "Internal Approval Draft": 5,
  "L1 Approval Pending": 5,
  "L1 Rejected": 5,
  "L1 Approved": 5,
  "L2 Approval Pending": 5,
  "L2 Rejected": 5,
  "L2 Approved": 5,
  "Internal Approval Completed": 5,
};

export const JobIconColor = {
  "Job Lead": "#000000",
  "Material and Trucking Details": "#9234C8",
  "Build Quote": "#12C730",
  "Quote Shared": "#E4800E",
  "Quote Approved": "#ab494f",
  "Internal Approval Draft": "#BB7676",
  "Internal Approval Completed": "#DC1D1D",
  "Dispatch Approved": "#1DD9DC",
  "L1 Approval Pending": "#DC1D1D",
  "L1 Rejected": "#DC1D1D",
  "L1 Approved": "#DC1D1D",
  "L2 Approval Pending": "#DC1D1D",
  "L2 Rejected": "#DC1D1D",
  "L2 Approved": "#DC1D1D",
  // unused
  Contacted: "#000000",
  "Quote Accepted": "#000000",
  "Quote Delivered": "#000000",
  Paused: "#000000",
  "Close Job": "#000000",
  "Generate Quote": "#000000",
};
